export default __webpack_public_path__ + "static/media/empty-project-budget.6e48f480.svg";